import { render, staticRenderFns } from "./WelcomeUser.vue?vue&type=template&id=0308abda"
import script from "./WelcomeUser.vue?vue&type=script&lang=js"
export * from "./WelcomeUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports